import { recordPage, recordEventCustomOnly, RELIABLE } from 'utilities/uTagging';
import UtagHelper from 'utilities/utagHelper';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';
import cryptoJS from 'crypto-js';

export const doTagSecurityVerification = userProfile => {
    const identificadorOnboarding = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
    recordPage(
        '/onboarding/transferencia-verificacion',
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        UtagHelper.getJointHolderInfoFromUserProfile(userProfile),
        undefined,
        undefined,
        userProfile.investmentType,
        {
            tipoProceso: 'onboarding',
            pasoProceso: 'tu-actividad',
            event_name: 'step_transfer_verification',
            pageName: '/onboarding/step9/transferVerification',
            sectionFamily: 'banking',
            sectionCategory: 'onboarding',
            sectionName: 'userOnboarding',
            interactionType: 'funnel',
            serviceType: 'onboarding',
            processType: 'onboarding',
            processStep: 'step9',
            processDetail: 'transferVerification',
            onboardingType: userProfile.investmentType,
            onboardingR: userProfile.clientRisk || '',
            onboardingIdMethod: RELIABLE[userProfile.identityMethod],
            identificadorOnboarding,
            onboardingOrigin: ORIGIN_BY_CHANNEL[userProfile.channel],
        }
    );
};

export const doTagHandleContinue = () => {
    recordEventCustomOnly({
        categoriaEvento: '/onboarding/transferencia-verificacion',
        accionEvento: 'continuar',
    });
};

export const doTagHandleCancel = () => {
    recordEventCustomOnly({
        categoriaEvento: '/onboarding/transferencia-verificacion',
        accionEvento: 'salir',
    });
};

export const doTagHandleCopyIban = () => {
    recordEventCustomOnly({
        categoriaEvento: '/onboarding/transferencia-verificacion',
        accionEvento: 'copiarIBAN',
    });
};
